<template>
  <!-- <el-cascader ref="myCascader" @change="handleChange" v-model="partyOrganId" placeholder="请选择" :props="areaprop"></el-cascader> -->

<!-- <el-cascader
     v-model="partyOrganId"
     :show-all-levels="false"
     ref="sysCascader"
     :props="prop"
     @change="handleChange($event)"
     clearable>
  </el-cascader> -->

	<el-cascader 
	v-model="statusVal" 
	:show-all-levels="false" 
	placeholder="按区域选择" 
	:props="staProps">
	</el-cascader>
</template>
 
<script>
export default {
    name: 'Apply',
    data() {
        return {
            staProps: {
                value: 'id',
                label: 'name',
                lazy: true,//设置lazyLoad，必须配合lazy：true
                checkStrictly: true,
                lazyLoad: this.getSta
                        },
            statusVal:{
                id: 0,
                level:0,
            }
          }
       },
    methods: {
        // async getSta() {
        //     const params = {};
        //     const data = await this.get(homeGetAreaList, { params: params }).then((data) => {
        //         return data.datas;
        //     });
        //     return data;
        // },

        getSta(node, resolve) {
            
                    const { data } = node;
                    
                    if (data && ((data.haschild === false) || (data.leaf === true))) {
                    //判断是否有子节点，若没有则进入该判断（判断条件因个人需求不同而不同）
                        return resolve([]);
                    }
                    
                    this.$get(this.$api.homeGetAreaList +node.level).then((req) => {
                        alert(node.level);
                        //接收到的子节点对象在req里，这里可以对数据进行处理之后，再渲染。
                        resolve(req.datas);
                    });
                },

    },
    created:{
        
    }
    
    }
</script>
